import {useFeatureAppEnv} from '@smart/feature-app/react';
import type {VariantType} from '../common/types';
export interface FeatureAppConfig {
  readonly variant: VariantType;
  readonly campaignId?: string;
}
export function useFeatureAppEnvHook() {
  return useFeatureAppEnv<FeatureAppConfig>();
}
